import { Component, Input, OnChanges } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../layout/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { ModalHeaderComponent } from '../modals/modal-header/modal-header.component';


@Component({
  selector: 'app-user-information-form',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    LoaderComponent,
    ModalHeaderComponent
  ],
  templateUrl: './user-information-form.component.html',
  styleUrl: './user-information-form.component.scss'
})
export class UserInformationFormComponent implements OnChanges {
  @Input() itemId: string = '';

  _item: any = {};
  @Input()
  set item(value: any) {
    this._item = value;
    this.onItemSet(value);
  }

  get item() {
    return this._item;
  }

  onItemSet(item: any) {
    if (this.item['id']) {
      this.modalTitle = 'Wijzig gebruiker';
    } else {
      this.modalTitle = 'Gebruiker toevoegen';
    }
  }

  organisations: any = [];
  roles: any = [];
  errorMessage: any = {};
  errors: any = {};
  loading: boolean = false;
  newPassword: string = '';

  modalTitle: string = 'Gebruiker toevoegen';
  modalStyle: boolean = false;

  constructor(
    private apiService: ApiService
  ) {
    this.getOrganisations();
    this.getRoles();
  }

  ngOnChanges(changes: any) {
    console.log('onchange');
    this.getItem();
    this.getOrganisations();
    this.getRoles();
  }

  save() {
    let self = this;

    self.reset();
    self.loading = true;

    const modal = document.querySelector('.modal');
    if (modal) {
      modal.scrollTo({ top: 0, behavior: 'smooth' });
    }

    if (this.item['id'] == undefined) {
      let postData = this.item;
      postData['password'] = self.newPassword;

      return this.apiService.post('/office/users', postData).then(function (response: any) {
        self.handleSucces(response);
      }).catch(function (e) {
        self.handleError(e);
      });
    }
    else {
      let postData = this.item;
      postData['password'] = self.newPassword;

      return this.apiService.put('/office/users/' + this.item['id'], postData).then(function (response: any) {
        self.handleSucces(response);
      }).catch(function (e) {
        self.handleError(e);
      });
    }
  }

  handleSucces(response: any) {
    let self = this;
    self.item = response;
    setTimeout(function () {
      self.loading = false;
      // self.activeModal.close(true);
    }, 200);
  }

  handleError(response: any) {
    let self = this;
    self.errors = response['error']['error'];
    self.errorMessage = response['error']['message'];
    self.loading = false;

    if (response.status == 500) {
      self.errorMessage = response['error']['message'];
      self.errors = [];
    }
  }

  reset() {
    this.errors = {};
    this.errorMessage = '';
  }

  getOrganisations() {
    let self = this;

    return this.apiService.get('/office/organisations').then(function (response: any) {
      self.organisations = response['data'];
    }).catch(function (e) { });
  }

  getRoles() {
    let self = this;

    return this.apiService.get('/office/roles').then(function (response: any) {
      self.roles = response['data'];
    }).catch(function (e) { });
  }

  getItem() {
    let itemId = this.itemId;
    let self = this;

    self.reset();
    if (this.itemId === '') {
      return;
    }
    return this.apiService.get('/office/users/' + itemId).then(function (response: any) {
      self.item = response;
      if (self.item['id']) {
        self.modalTitle = 'Wijzig gebruiker';
      } else {
        self.modalTitle = 'Gebruiker toevoegen';
      }
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }
}
